import { FunctionComponent } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { LoadingIndicator } from './LoadingIndicator';

export const LoadingButton: FunctionComponent<Partial<ButtonProps>> = (props) => {
  return <Button loadingIndicator={<LoadingIndicator />} {...props} />;
};
